import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DraggableDirective } from './draggable.directive';
import { OutsideClickDirective } from './outside.click.directive';

@NgModule({
  declarations: [
    DraggableDirective,
    OutsideClickDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DraggableDirective,
    OutsideClickDirective
  ]
})
export class DraggableModule { }
